/* Part-request form.

   Delivery is Shopify's native contact form: the markup is rendered by Liquid's
   {% form 'contact' %} tag so Shopify attaches its invisible CAPTCHA token, and
   we let the browser submit it normally. An earlier version built a form in JS
   and POSTed it to /contact — Shopify rejected every one of those with
   "Missing CAPTCHA token", so do not reintroduce that.

   Two things happen around the native submit:
     1. the values are stashed in sessionStorage so the confirmation screen can
        recap them after Shopify's redirect, which does not repopulate fields;
     2. if a notify endpoint is configured, a fire-and-forget POST sends a copy
        to Slack. It never blocks or gates the submission. */
(function () {
  var STASH = 'bp_part_request';

  function init(root) {
    var form = root.querySelector('form[action*="/contact"]'),
        endpoint = (root.getAttribute('data-endpoint') || '').trim(),
        emailFld = root.querySelector('[data-prf-emailfld]'),
        wrapForm = root.querySelector('[data-prf-form]'),
        wrapThanks = root.querySelector('[data-prf-thanks]');
    if (!form) return;

    var pn = root.querySelector('[data-prf-pn]'),
        brand = root.querySelector('[data-prf-brand]'),
        note = root.querySelector('[data-prf-note]'),
        email = root.querySelector('[data-prf-email]'),
        hp = root.querySelector('[data-prf-hp]');

    var p = new URLSearchParams(location.search);

    // Shopify redirects back here with ?contact_posted=true on success.
    if (p.get('contact_posted') === 'true') { showThanks(); return; }

    if (p.get('pn') && pn) pn.value = p.get('pn');
    if (p.get('brand') && brand) brand.value = p.get('brand');

    function valid(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }

    function showThanks() {
      var d = {};
      try { d = JSON.parse(sessionStorage.getItem(STASH) || '{}'); } catch (e) { d = {}; }
      try { sessionStorage.removeItem(STASH); } catch (e) {}
      root.querySelector('[data-prf-temail]').textContent = d.email || 'the address you gave us';
      root.querySelector('[data-prf-tpn]').textContent = d.part_number || '—';
      root.querySelector('[data-prf-tbrand]').textContent = d.brand || 'Not specified';
      root.querySelector('[data-prf-tnote]').textContent = d.notes || 'None';
      wrapForm.hidden = true; wrapThanks.hidden = false;
      window.scrollTo(0, 0);
    }

    form.addEventListener('submit', function (e) {
      if (hp && hp.value) { e.preventDefault(); return; } // honeypot

      var addr = (email.value || '').trim();
      if (!valid(addr)) {
        e.preventDefault();
        emailFld.classList.add('is-err');
        email.focus();
        return;
      }
      emailFld.classList.remove('is-err');

      var d = {
        part_number: (pn.value || '').trim(),
        brand: (brand.value || '').trim(),
        notes: (note.value || '').trim(),
        email: addr,
        source: location.href,
        submitted_at: new Date().toISOString()
      };
      try { sessionStorage.setItem(STASH, JSON.stringify(d)); } catch (err) {}

      // Side-channel only. Never preventDefault on its account, never await it.
      //
      // The body is JSON but is sent as text/plain deliberately. Both sendBeacon
      // and fetch would otherwise trigger a CORS preflight on a cross-origin
      // application/json POST, and sendBeacon cannot perform one — the ping would
      // be dropped silently. text/plain is a CORS-safelisted content type, so the
      // request goes straight out. The Worker parses the body as JSON regardless.
      if (endpoint) {
        try {
          var body = JSON.stringify(d);
          var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
          if (!navigator.sendBeacon || !navigator.sendBeacon(endpoint, blob)) {
            fetch(endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
              body: body,
              keepalive: true,
              mode: 'cors'
            }).catch(function () {});
          }
        } catch (err) {
          if (window.console) console.error('[part-request] notify failed', err);
        }
      }
      // fall through: the native form submits and Shopify sends the mail
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-part-request]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
